function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M100 193.84c-51.75 0-93.84-42.1-93.84-93.84S48.25 6.16 100 6.16s93.84 42.1 93.84 93.84-42.09 93.84-93.84 93.84zm0-176.68c-45.68 0-82.84 37.16-82.84 82.84s37.16 82.84 82.84 82.84 82.84-37.16 82.84-82.84S145.68 17.16 100 17.16z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M152.33 90.22h-42.66V47.81c0-5.51-4-9.97-9.5-9.97s-9.5 4.46-9.5 9.97v42.41H47.95c-5.5 0-9.97 4.49-9.97 10s4.46 10 9.97 10h42.72v41.98c0 5.51 4 9.97 9.5 9.97s9.5-4.46 9.5-9.97v-41.98h42.66c5.5 0 9.97-4.49 9.97-10s-4.46-10-9.97-10z"
});

var SvgAdd = function SvgAdd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 200 200",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add.6f64cf86.svg";
export { ForwardRef as ReactComponent };